import { ReactElement, useEffect, useState } from "react";

import { Collection } from "../../../generated/gql/graphql";
import useCollections from "../../../hooks/query/collection/use-collections";
import { parseType } from "../../../utils/graphql";
import MetaSelect from "../parts/meta-select";

type Props = {
  onChange(collection?: Collection): void;
};

export default function CollectionSelector(props: Props): ReactElement {
  const { onChange } = props;

  const [options, setOptions] = useState<Collection[]>([]);
  const { data } = useCollections();

  useEffect(() => {
    if (!data) {
      return;
    }

    setOptions(parseType<Collection[]>("collections", data));
  }, [data]);

  return (
    <MetaSelect
      label="Collection"
      name="value"
      getOptions={options}
      setOption={(v) => onChange(v["value"])}
      list={options.map((v) => ({ text: v.name, value: v }))}
    />
  );
}
